/**
 * Member account history rendering helpers.
 *
 * Backend: GET /api/v1/customers/{id}/account-history
 * Items include recorded_at, submitted_by/at, approved_by/at, created_by/at, etc.
 */

function isWorkflowEntry(item) {
	if (!item || typeof item !== "object") {
		return false;
	}
	const hasRequestId = item.request_id != null && String(item.request_id) !== "";
	const ev = (item.event || "").toString().toLowerCase();
	const isApprovalEvent = ["approved", "final_approved", "rejected"].includes(ev);
	const logName = (item.log_name || "").toString();
	return hasRequestId || isApprovalEvent || logName === "Approve Member";
}

function isSubmissionOnlyEntry(item) {
	if (!item || typeof item !== "object") {
		return false;
	}
	const logName = (item.log_name || "").toString();
	const label = (item.event_label || "").toString().toLowerCase();
	return (
		logName === "Update Request" ||
		label === "update request" ||
		label.includes("update request")
	);
}

function formatUserDisplayName(user) {
	if (!user || typeof user !== "object") {
		return "";
	}
	const full = (user.full_name || "").toString().trim();
	if (full) {
		return full;
	}
	const parts = [
		user.first_name,
		user.middle_name,
		user.surname,
	]
		.map((x) => (x == null ? "" : String(x).trim()))
		.filter(Boolean);
	if (parts.length) {
		return parts.join(" ");
	}
	const uname = (user.username || "").toString().trim();
	return uname || (user.id != null ? `User #${user.id}` : "");
}

function buildActorSections(item) {
	/**
	 * Returns ordered sections for UI:
	 * - { key, label, name, at }
	 */
	if (!item || typeof item !== "object") {
		return [];
	}

	// Request submission entries: Submitted by only.
	if (isSubmissionOnlyEntry(item)) {
		const submittedName = formatUserDisplayName(item.submitted_by);
		return [
			{
				key: "submitted",
				label: "Submitted by",
				name: submittedName || "Unknown",
				at: item.submitted_at || null,
			},
		];
	}

	// Workflow entries: Submitted + Approved/Rejected (as available).
	if (isWorkflowEntry(item)) {
		const sections = [];

		const submittedName = formatUserDisplayName(item.submitted_by);
		sections.push({
			key: "submitted",
			label: "Submitted by",
			name: submittedName || "Unknown",
			at: item.submitted_at || null,
		});

		const ev = (item.event || "").toString().toLowerCase();
		const isRejected = ev === "rejected";
		const approvedName = formatUserDisplayName(item.approved_by);
		if (item.approved_by != null || item.approved_at != null) {
			sections.push({
				key: "approved",
				label: isRejected ? "Rejected by" : "Approved by",
				name: approvedName || "Unknown",
				at: item.approved_at || null,
			});
		}

		return sections;
	}

	// Non-workflow entries: Created by only.
	const createdName = formatUserDisplayName(item.created_by);
	return [
		{
			key: "created",
			label: "Created by",
			name: createdName || "Unknown",
			at: item.created_at || null,
		},
	];
}

module.exports = {
	isWorkflowEntry,
	isSubmissionOnlyEntry,
	formatUserDisplayName,
	buildActorSections,
};

